export default {
    decisions: state => state.decisions,
    decisionsLoading: state => state.decisionsLoading,
    representatives: state => state.representatives,
    representativesLoading: state => state.representativesLoading,
    organs: state => state.organs,
    organsLoading: state => state.organsLoading
};
